import { render, staticRenderFns } from "./ArchivedDesigns.vue?vue&type=template&id=7b49f97a&"
import script from "./ArchivedDesigns.vue?vue&type=script&lang=js&"
export * from "./ArchivedDesigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports